module.exports = __webpack_public_path__ + "img/0Q3A8622_L_Wood.9cf4410c.jpg";